import PreimageVirtualTourViewerLogo from "./PreimageVirtualTourViewerLogo";

export default PreimageVirtualTourViewerLogo;
